module.exports = __webpack_public_path__ + "html/password-change.template.html";